<div class="language-dropdown-container">
  <div class="language-button">
    <i class="pi pi-globe globe-icon"></i>
    <p-dropdown [options]="langs" placeholder="Language" [(ngModel)]="selectedLang" appendTo="body" styleClass="language-dropdown"></p-dropdown>
  </div>
</div>
<div class="container">
  <h2 id="help-en">{{ data[selectedLang].header }}</h2>
  <p>{{ data[selectedLang].description }}</p>
  <ol>
    <li *ngFor="let item of data[selectedLang].items">
      <h3>{{ item.header }}</h3>
      <ul *ngFor="let el of item.items">
        <li [innerHTML]="el"></li>
      </ul>
    </li>
  </ol>
</div>
